import React from "react";
import { ProfileComponent } from "../../Components/index";

const Profile = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-12 p-3">
          <ProfileComponent />
        </div>
      </div>
    </div>
  );
};

export default Profile;
